'use strict';

var AppState = require('app_state');
var MenubarView = require('components/menubar/views/menubar_view');

var MenubarController = {};

var view = undefined;
MenubarController.viewReset = false;

MenubarController.showMenubar = function (optionalEntries) {
    if (view === undefined || MenubarController.viewReset) {
        view = new MenubarView({
            optionalEntries: optionalEntries,
            lastAlarmCount: this.lastAlarmCount,
            alarmBlinking: this.alarmBlinking,
        });
        AppState.layout.showChildView('menu', view);
    } else {
        view.collection = collection;
        view.render();
    }
};

MenubarController.changeStatus = function (status) {
    view.setStatus(status);
    view.render();
};

MenubarController.resetMenubar = function () {
    // keep the number of alarms
    if (view) {
        this.lastAlarmCount = view.lastAlarmCount;
        this.alarmBlinking = view.alarmBlinking;
    }
    MenubarController.viewReset = true;
};

module.exports = MenubarController;
